// Centralised image registry — swap a single key here and it updates
// everywhere it's used.
//
// Image discipline (as of 2026-02):
//   • Property/home imagery → REAL Alpha photography under /public/homes/…
//   • Service tiles / hero backdrops → neutral photographic-style SVG
//     content tiles (`svgContentTileUrl`) — no aged-care, no clinical,
//     no luxury real-estate, no cartoons, no generic corporate stock.
//   • Team photos → replaced with icon-based team cards on the About page.
//
// All external Unsplash URLs were removed 2026-02 after luxury / mansion /
// generic-corporate stock leaked into the property listings and About page.

import { svgContentTileUrl } from "./propertyPlaceholders";

const tile = (key, label) => svgContentTileUrl(key, label);

export const IMG = {
  // Hero — uses real Alpha home photography.
  heroLifestyle: "/homes/aintree/5.jpg",            // open-plan living, real Alpha home
  heroHomes: "/homes/coburg/1.jpg",                 // real Alpha SIL home
  heroIntake: tile("intake", "Warm intake · Registered NDIS provider"),

  // Service tiles — neutral photographic-style content tiles.
  silTile: tile("sil", "SIL · Supported Independent Living"),
  sdaTile: tile("sda", "SDA · Specialist Disability Accommodation"),
  communityNursingTile: tile("nursing", "Community Nursing"),
  supportCoordinationTile: tile("coordination", "Support Coordination"),
  communityParticipationTile: tile("community", "Community Participation"),
  dailyLivingTile: tile("daily-living", "Daily Living Support"),

  // For-Participants — real Alpha bedroom photo (accessible interior).
  forParticipantsHero: "/homes/aintree/7.jpg",

  // For-Coordinators / referral — neutral content tile.
  coordinatorHero: tile("coordinator", "Support Coordinators · Warm referrals"),

  // About — team cards are now icon-based (see AboutPage).
  // These keys are kept so any legacy consumer still resolves to a clean tile.
  teamLeadership: tile("team-leadership", "Leadership"),
  teamOperations: tile("team-operations", "Operations"),
  teamClinical: tile("team-clinical", "Clinical"),
  teamHousing: tile("team-housing", "Housing"),

  // Video poster — real Alpha kitchen photo.
  videoPoster: "/homes/coburg/4.jpg",
};

export default IMG;
